import { render, staticRenderFns } from "./DebitNoteColumns.vue?vue&type=template&id=1ef9fa26&scoped=true"
import script from "./DebitNoteColumns.vue?vue&type=script&lang=js"
export * from "./DebitNoteColumns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef9fa26",
  null
  
)

export default component.exports